/* eslint-disable camelcase */
import type { Address } from '@rechargeapps/storefront-client'

import type { ShopifyBasicOrderShippingAddress } from '@lib/queries/orders/get-basic-orders-query'

type CustomizationCardProps = {
	className?: string
	shippingInfo?: Address | ShopifyBasicOrderShippingAddress
}

export default function CustomizationCard({ className, shippingInfo }: CustomizationCardProps) {
	return shippingInfo ? (
		<address
			className={`not-italic border-solid border-[2px] border-gray-300 p-[16px] mb-[16px] ${className}`}
		>
			<p className="font-bold mb-2">Box shipping address:</p>
			<p>
				{(shippingInfo as Address).first_name ||
					(shippingInfo as ShopifyBasicOrderShippingAddress).firstName}{' '}
				{(shippingInfo as Address).last_name ||
					(shippingInfo as ShopifyBasicOrderShippingAddress).lastName}
			</p>
			<p>
				{shippingInfo.address1}
				{shippingInfo.address2 ? `, ${shippingInfo.address2}` : ''}
			</p>
			<p>
				{shippingInfo.city}, {shippingInfo.province}, {shippingInfo.zip}
			</p>
		</address>
	) : null
}
